import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ShopMenusPage from './pages/ShopMenusPage';

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '');
      const scrollToTarget = () => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      if (!scrollToTarget()) {
        const timer = setTimeout(scrollToTarget, 150);
        return () => clearTimeout(timer);
      }

      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.hash, location.pathname]);

  return null;
};

const AppLayout = () => (
  <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
    <ScrollManager />
    <Header />
    <main className="flex-1">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/shops/:shopSlug/menus" element={<ShopMenusPage />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

const App = () => (
  <Router>
    <AppLayout />
  </Router>
);

export default App;
